import React, {ReactNode} from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Button, Checkbox, Paper, Typography} from "@material-ui/core";
import {IPointCoords, INotificacion, IParcela, ISections} from "../../../types";
import {LatLngTuple} from "leaflet";
import {getCenterZoom} from "../../../tools/getCenterZoom";
import config from "../../../config.json";
import axios from "axios";
import {userService} from "../../../services/UserService";
import {parseNameParcela} from "../../../tools/ParseNameParcela";
import {Help} from "@material-ui/icons";
import Email from "../../../icons/PNGs/email.png";
import Telegram from "../../../icons/PNGs/telegram.png";

const texts = require('../../../texts/configuracion.json');


interface IProps {
    notify(notification: INotificacion): void
    openNota(callback: string): void
    parcelas: IParcela[]
    usuario: string
    idioma: string
}

interface IState {
    clicked: string
    pronostico_tiempo: string
    nuevas_imagenes: string
    posible_problema: string
    text: Record<string, string>
}

class Notificaciones extends React.Component<IProps, IState> {
    state: IState = {
        clicked: '',
        pronostico_tiempo: '',
        nuevas_imagenes: '',
        posible_problema: '',
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        if (nextState.clicked !== '' && this.state.clicked === nextState.clicked) {
            if (this.state.pronostico_tiempo !== nextState.pronostico_tiempo ||
                this.state.nuevas_imagenes !== nextState.nuevas_imagenes ||
                this.state.posible_problema !== nextState.posible_problema) {

                const data = {
                    "id": this.props.usuario + '_' + this.state.clicked,
                    "pronostico_tiempo": nextState.pronostico_tiempo,
                    "nuevas_imagenes": nextState.nuevas_imagenes,
                    "posible_problema": nextState.posible_problema
                }

                axios.post(
                    config.url+'/edit/notifications',
                    data,
                    {auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }
                    })
                    .then((res) => {

                    })
                    .catch(() => {
                        this.props.notify({message: 'Error interno', variant: 'error'})
                    })
            }
        }
        return true
    }

    IdNombreParcela = ():Record<string, string>[] => {
        const id2name: Record<string, string>[] = []
        for (const parcela of this.props.parcelas) {
            if (parcela.eliminada === 1) continue
            if (!parcela.propietario.split(',').includes(this.props.usuario)) continue
            id2name.push({
                id: parcela.id,
                nombre: parcela.nombre
            })
        }
        return id2name
    }

    handleOpenClick = (id: string) => {

        axios.get(
            config.url+`/get/notifications?user=${this.props.usuario}&parcela=${id}`,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res) => {
                this.setState({
                    clicked: id,
                    pronostico_tiempo: res.data.data.pronostico_tiempo,
                    nuevas_imagenes: res.data.data.nuevas_imagenes,
                    posible_problema: res.data.data.posible_problema
                })
            })
            .catch(() => {
                this.props.notify({message: 'Error interno', variant: 'error'})
            })
    }

    render () {
        const options = this.IdNombreParcela()
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignSelf: "start",
                    height: '100%',
                    width: '100%',
                    marginLeft: 20,
                    overflow: "auto"
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                {options.map(element =>
                    <Paper
                        key={element.id}
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            marginTop: 20,
                            marginLeft: 2,
                            marginBottom: 2,
                            width: "40vw"
                        }}
                    >
                        {this.state.clicked !== element.id?
                            <Button
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-start",
                                    width: '100%'
                                }}
                                onClick={() => this.handleOpenClick(element.id)}
                            >
                                <Typography
                                    style={{
                                        fontSize: 18,
                                        fontWeight: "bold",
                                        color: "#4C494B",
                                        fontFamily: "Poppins",
                                        margin: 5
                                    }}
                                >
                                    {parseNameParcela(element.nombre)}
                                </Typography>
                            </Button>
                            :
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: '100%',
                                    height: "fit-content",
                                    alignItems: "flex-start"
                                }}
                            >
                                <Button
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "flex-start",
                                        width: '100%'
                                    }}
                                    onClick={() => {
                                            this.setState({clicked: ''})
                                    }}
                                >
                                    <Typography
                                        style={{
                                            fontSize: 18,
                                            fontWeight: "bold",
                                            color: "#4C494B",
                                            fontFamily: "Poppins",
                                            margin: 5
                                        }}
                                    >
                                        {parseNameParcela(element.nombre)}
                                    </Typography>
                                </Button>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column"
                                    }}
                                >

                                    <Typography
                                        style={{
                                            fontSize: 14,
                                            color: "#4C494B",
                                            fontFamily: "Poppins",
                                            margin: 5,
                                            marginLeft: 10
                                        }}
                                    >
                                        {this.state.text["23"]}
                                        <br/>
                                        {this.state.text["24"]}
                                        <br/>
                                        {this.state.text["25"]}
                                    </Typography>

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}
                                    >

                                        <Typography
                                            style={{
                                                fontSize: 42,
                                                color: "#4C494B",
                                                fontFamily: "Poppins",
                                                margin: 5,
                                                marginLeft: 10
                                            }}
                                        >
                                            ·
                                        </Typography>

                                        <Typography
                                            style={{
                                                fontSize: 16,
                                                fontWeight: "bold",
                                                color: "#4C494B",
                                                fontFamily: "Poppins",
                                                margin: 5
                                            }}
                                        >
                                            {this.state.text["26"]}
                                        </Typography>

                                        <Help
                                            style={{
                                                width: 20,
                                                height: 20
                                            }}
                                            onClick={() => this.props.openNota(this.state.text["27"])}
                                        />

                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            marginLeft: 20,
                                            marginTop: -20
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                marginRight: 40
                                            }}
                                        >
                                            <Checkbox
                                                color={"primary"}
                                                checked={this.state.pronostico_tiempo.includes('email')}
                                                onChange={() => {
                                                    if (this.state.pronostico_tiempo.includes('email')) {
                                                        let plataformas = []
                                                        for (let plataforma of this.state.pronostico_tiempo.split('_')) {
                                                            if (plataforma !== 'email') plataformas.push(plataforma)
                                                        }
                                                        this.setState({pronostico_tiempo: plataformas.join('_')})

                                                    } else {
                                                        if (this.state.pronostico_tiempo.length !== 0) {
                                                            this.setState({pronostico_tiempo: ['email', this.state.pronostico_tiempo].join('_')})
                                                        } else {
                                                            this.setState({pronostico_tiempo: 'email'})
                                                        }
                                                    }
                                                }}
                                            />
                                            <Typography
                                                style={{
                                                    fontSize: 16,
                                                    color: "#4C494B",
                                                    fontFamily: "Poppins",
                                                    margin: 5
                                                }}
                                            >
                                                e-mail
                                            </Typography>

                                            <img
                                                style={{width: 25, height: 25}}
                                                src={Email}
                                                alt={''}
                                            />

                                        </div>


                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Checkbox
                                                color={"primary"}
                                                checked={this.state.pronostico_tiempo.includes('telegram')}
                                                onChange={() => {
                                                    if (this.state.pronostico_tiempo.includes('telegram')) {
                                                        let plataformas = []
                                                        for (let plataforma of this.state.pronostico_tiempo.split('_')) {
                                                            if (plataforma !== 'telegram') plataformas.push(plataforma)
                                                        }
                                                        this.setState({pronostico_tiempo: plataformas.join('_')})

                                                    } else {
                                                        if (this.state.pronostico_tiempo.length !== 0) {
                                                            this.setState({pronostico_tiempo: ['telegram', this.state.pronostico_tiempo].join('_')})
                                                        } else {
                                                            this.setState({pronostico_tiempo: 'telegram'})
                                                        }
                                                    }
                                                }}
                                            />
                                            <Typography
                                                style={{
                                                    fontSize: 16,
                                                    color: "#4C494B",
                                                    fontFamily: "Poppins",
                                                    margin: 5
                                                }}
                                            >
                                                Telegram
                                            </Typography>

                                            <img
                                                style={{width: 25, height: 25}}
                                                src={Telegram}
                                                alt={''}
                                            />

                                        </div>
                                    </div>



                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}
                                    >

                                        <Typography
                                            style={{
                                                fontSize: 42,
                                                color: "#4C494B",
                                                fontFamily: "Poppins",
                                                margin: 5,
                                                marginLeft: 10
                                            }}
                                        >
                                            ·
                                        </Typography>

                                        <Typography
                                            style={{
                                                fontSize: 16,
                                                fontWeight: "bold",
                                                color: "#4C494B",
                                                fontFamily: "Poppins",
                                                margin: 5
                                            }}
                                        >
                                            {this.state.text["28"]}
                                        </Typography>

                                        <Help
                                            style={{
                                                width: 20,
                                                height: 20
                                            }}
                                            onClick={() => this.props.openNota(this.state.text["30"])}
                                        />

                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            marginLeft: 20,
                                            marginTop: -20
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                marginRight: 40
                                            }}
                                        >
                                            <Checkbox
                                                color={"primary"}
                                                checked={this.state.nuevas_imagenes.includes('email')}
                                                onChange={() => {
                                                    if (this.state.nuevas_imagenes.includes('email')) {
                                                        let plataformas = []
                                                        for (let plataforma of this.state.nuevas_imagenes.split('_')) {
                                                            if (plataforma !== 'email') plataformas.push(plataforma)
                                                        }
                                                        this.setState({nuevas_imagenes: plataformas.join('_')})

                                                    } else {
                                                        if (this.state.nuevas_imagenes.length !== 0) {
                                                            this.setState({nuevas_imagenes: ['email', this.state.nuevas_imagenes].join('_')})
                                                        } else {
                                                            this.setState({nuevas_imagenes: 'email'})
                                                        }
                                                    }
                                                }}
                                            />
                                            <Typography
                                                style={{
                                                    fontSize: 16,
                                                    color: "#4C494B",
                                                    fontFamily: "Poppins",
                                                    margin: 5
                                                }}
                                            >
                                                e-mail
                                            </Typography>

                                            <img
                                                style={{width: 25, height: 25}}
                                                src={Email}
                                                alt={''}
                                            />

                                        </div>


                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Checkbox
                                                color={"primary"}
                                                checked={this.state.nuevas_imagenes.includes('telegram')}
                                                onChange={() => {
                                                    if (this.state.nuevas_imagenes.includes('telegram')) {
                                                        let plataformas = []
                                                        for (let plataforma of this.state.nuevas_imagenes.split('_')) {
                                                            if (plataforma !== 'telegram') plataformas.push(plataforma)
                                                        }
                                                        this.setState({nuevas_imagenes: plataformas.join('_')})

                                                    } else {
                                                        if (this.state.nuevas_imagenes.length !== 0) {
                                                            this.setState({nuevas_imagenes: ['telegram', this.state.nuevas_imagenes].join('_')})
                                                        } else {
                                                            this.setState({nuevas_imagenes: 'telegram'})
                                                        }
                                                    }
                                                }}
                                            />
                                            <Typography
                                                style={{
                                                    fontSize: 16,
                                                    color: "#4C494B",
                                                    fontFamily: "Poppins",
                                                    margin: 5
                                                }}
                                            >
                                                Telegram
                                            </Typography>

                                            <img
                                                style={{width: 25, height: 25}}
                                                src={Telegram}
                                                alt={''}
                                            />

                                        </div>
                                    </div>



                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}
                                    >

                                        <Typography
                                            style={{
                                                fontSize: 42,
                                                color: "#4C494B",
                                                fontFamily: "Poppins",
                                                margin: 5,
                                                marginLeft: 10
                                            }}
                                        >
                                            ·
                                        </Typography>

                                        <Typography
                                            style={{
                                                fontSize: 16,
                                                fontWeight: "bold",
                                                color: "#4C494B",
                                                fontFamily: "Poppins",
                                                margin: 5
                                            }}
                                        >
                                            {this.state.text["29"]}
                                        </Typography>

                                        <Help
                                            style={{
                                                width: 20,
                                                height: 20
                                            }}
                                            onClick={() => this.props.openNota(this.state.text["31"])}
                                        />

                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            marginLeft: 20,
                                            marginTop: -20
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                marginRight: 40
                                            }}
                                        >
                                            <Checkbox
                                                color={"primary"}
                                                checked={this.state.posible_problema.includes('email')}
                                                onChange={() => {
                                                    if (this.state.posible_problema.includes('email')) {
                                                        let plataformas = []
                                                        for (let plataforma of this.state.posible_problema.split('_')) {
                                                            if (plataforma !== 'email') plataformas.push(plataforma)
                                                        }
                                                        this.setState({posible_problema: plataformas.join('_')})

                                                    } else {
                                                        if (this.state.posible_problema.length !== 0) {
                                                            this.setState({posible_problema: ['email', this.state.posible_problema].join('_')})
                                                        } else {
                                                            this.setState({posible_problema: 'email'})
                                                        }
                                                    }
                                                }}
                                            />
                                            <Typography
                                                style={{
                                                    fontSize: 16,
                                                    color: "#4C494B",
                                                    fontFamily: "Poppins",
                                                    margin: 5
                                                }}
                                            >
                                                e-mail
                                            </Typography>

                                            <img
                                                style={{width: 25, height: 25}}
                                                src={Email}
                                                alt={''}
                                            />

                                        </div>


                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Checkbox
                                                color={"primary"}
                                                checked={this.state.posible_problema.includes('telegram')}
                                                onChange={() => {
                                                    if (this.state.posible_problema.includes('telegram')) {
                                                        let plataformas = []
                                                        for (let plataforma of this.state.posible_problema.split('_')) {
                                                            if (plataforma !== 'telegram') plataformas.push(plataforma)
                                                        }
                                                        this.setState({posible_problema: plataformas.join('_')})

                                                    } else {
                                                        if (this.state.posible_problema.length !== 0) {
                                                            this.setState({posible_problema: ['telegram', this.state.posible_problema].join('_')})
                                                        } else {
                                                            this.setState({posible_problema: 'telegram'})
                                                        }
                                                    }
                                                }}
                                            />
                                            <Typography
                                                style={{
                                                    fontSize: 16,
                                                    color: "#4C494B",
                                                    fontFamily: "Poppins",
                                                    margin: 5
                                                }}
                                            >
                                                Telegram
                                            </Typography>

                                            <img
                                                style={{width: 25, height: 25}}
                                                src={Telegram}
                                                alt={''}
                                            />

                                        </div>
                                    </div>

                                </div>

                            </div>
                        }

                    </Paper>
                )}

            </div>
        )
    }

}

const mapStateToProps = (state: IStore) => ({
    parcelas: state.principal.parcelas,
    usuario: state.principal.usuario,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    openNota: (callback: string) => dispatch({type: "open-nota-dialog", callback})
});

export default connect(mapStateToProps, mapDispatchToProps)(Notificaciones);
